module.exports = __webpack_public_path__ + "img/melia-kids.2384cbbe.jpg";